import React from 'react'
import GatsbyImage from 'gatsby-image'
import { StaticQuery, graphql } from 'gatsby'
import styled from '@emotion/styled'
import ThemeConsumer from '@/hoc/ThemeConsumer'
import { layouts } from '@/utils/preset'
import { tablet, mobile } from '@/utils/media'
import { mq, rem } from '@/utils/helpers'
import Typography from '@/components/common/Typography'

const Template = props => {
  const { ...others } = props
  return (
    <StaticQuery
      query={query}
      render={data => {
        return (
          <Root {...others}>
            <Bg>
              <Bg_Image fluid={data.bg.childImageSharp.fluid} />
            </Bg>
            <Container>
              <Left>
                <Heading variant="d5">気軽にご連絡ください！</Heading>
                <Message variant="body3">フロントビジョンはものづくりの会社でもあり、自社でECサイト・メディアを運営しています。メーカーとWEB制作会社というビジネスの両輪により、依頼主様と同じ目線で一緒に考え、最適なロードマップを提示することができます。ECサイトを最大限にご活用いただけるよう、協力させてください。</Message>
              </Left>
              <Right>
                <Image fluid={data.image.childImageSharp.fluid} alt="FRONT VISION 代表" />
              </Right>
            </Container>
          </Root>
        )
      }}
    />
  )
}

export default ThemeConsumer(Template)

const Root = styled.div`
  position: relative;
  background-color: ${props => props.theme.gray.b};
  padding: ${rem(56)} ${rem(layouts.defs.pad.base)};
  overflow: hidden;
  @media ${mq.and(tablet)} {
    padding: ${rem(60)} ${rem(layouts.defs.pad.tablet)};
  }
  @media ${mq.and(mobile)} {
    padding: ${rem(56)} ${rem(layouts.defs.pad.mobile)} ${rem(56)};
  }
`

const Bg = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: none;

  @media ${mq.and(mobile)} {
    display: none;
  }
`

const Bg_Image = styled(GatsbyImage)``

const Container = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  margin: 0 auto;
  max-width: ${rem(731)};

  @media ${mq.and(mobile)} {
    display: block;
    max-width: 100%;
  }
`

const Left = styled.div`
  width: ${rem(340)};
  @media ${mq.and(mobile)} {
    width: 100%;
  }
`

const Right = styled.div`
  margin-left: ${rem(24)};
  flex-grow: 1;
  @media ${mq.and(mobile)} {
    margin-top: ${rem(24)};
    margin-left: 0;
    width: 100%;
  }
`

const Heading = styled(Typography)`
  @media ${mq.and(mobile)} {
    text-align: center;
  }
`

const Message = styled(Typography)`
  margin-top: ${rem(16)};
`

const Image = styled(GatsbyImage)`
  width: 100%;
`

export const query = graphql`
  query CVSectionQuery {
    image: file(relativePath: { eq: "cv.png" }) {
      childImageSharp {
        fluid(maxWidth: 624) {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
    }
    bg: file(relativePath: { eq: "cv-bg.png" }) {
      childImageSharp {
        fluid(maxWidth: 1556) {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
    }
  }
`
